import React from "react";

import bannerImg from "../../../../Assets/Images/Clip path group.png";
import { motion } from "framer-motion";
import "./DatabaseBanner.css";
import "../AllBanner/technologiesBanner.css";
import { Link } from "react-router-dom";

const MobBanner = () => {
  return (
    <div
      className="tech-web-banner"
      style={{ backgroundColor: " #0b4f5d", color: "white" }}
    >
      <div
        className="d-flex flex-column flex-md-row align-items-center py-5"
        style={{
          padding: "1rem 0",
          gap: "80px",
          width: "90%",
          margin: "0 auto",
        }}
      >
        {/* Left Text Section */}
        <div
          className="d-flex flex-column justify-content-center"
          style={{
            flex: "1",
            maxWidth: "636px",
          }}
        >
          <h4
            className=" sub-heading text-center text-md-start "
            style={{ color: "#F7A630" }}
          >
            Mobile Technologies and Frameworks
          </h4>
          <h2 className="database-heading web-tech-heading fw-semibold text-center text-md-start mb-3">
            Mobile Technology Chosen From The Ground Up
          </h2>
          <p className="small px-2 database-text text-center text-md-start  mb-4">
            Mobile apps don't exist in perfect worlds, but in pockets. They are
            unlocked in elevators, taxis, poor Wi-Fi areas, and times of
            distraction. That reality influences the way we think about mobile
            technology here at Quad Theory Ltd. Rather than beginning with
            features, we begin with constraints. Device limits, network drops,
            OS behaviour, and user patience.
          </p>

          <Link className="mx-auto mx-md-0" to="/contact-us">
            <motion.button
              type="button"
              className=" px-5 py-3 mx-auto mx-md-0 rounded-pill align-self-start"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                fontSize: "1.4rem",
              }}
            >
              Explore Our Mobile Stack
            </motion.button>
          </Link>
        </div>

        {/* Right Image Section */}
        <div style={{ flex: "1", position: "relative", textAlign: "center" }}>
          <img
            src={bannerImg}
            alt="Banner"
            className="img-fluid tech_mob_banner_img"
            style={{
              mixBlendMode: "brighten",
              opacity: 2.0,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default MobBanner;
